import { Spin } from "antd";
import React, { Suspense } from "react";

import { requestWithAuth } from "@skydio/api_util/src/backends/cloud_api/requests-browser";

import { useSuspendingFileCache } from "hooks/useSuspendingFileCache";

import type { CSSProperties } from "react";

type Props = {
  src: string;
  style?: CSSProperties;
  alt?: string;
  className?: string;
  onClick?: () => void;
};

export const fallbackImage =
  "data:image/png;base64,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";

export async function loadImagePromise(url: string): Promise<string> {
  const resp = await requestWithAuth(url);
  const blob = await resp.blob();
  const output = URL.createObjectURL(blob);
  return output;
}

export const SuspendingImage: React.FC<Props> = ({ src, alt, ...props }) => {
  const { result } = useSuspendingFileCache(src, loadImagePromise, fallbackImage);

  return <img src={result} alt={alt} {...props} />;
};

const LoadingState: React.FC<Props> = ({ style, className }) => {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        ...style,
      }}
      className={className}
    >
      <Spin />
    </div>
  );
};

const SuspendingImageWrapper: React.FC<Props> = props => {
  return (
    <Suspense fallback={<LoadingState {...props} />}>
      <SuspendingImage {...props} />
    </Suspense>
  );
};

export default SuspendingImageWrapper;
